var _g, _defs;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIcnMenuNovel = function SvgIcnMenuNovel(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6851_308533)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7 17.5003H24.5M24.5 22.167H7M17.5 12.8337H24.5M24.5 8.16699H17.5M10.5 10.5003H11.6667C11.8974 10.5003 12.123 10.5687 12.3148 10.6969C12.5067 10.8251 12.6562 11.0073 12.7445 11.2205C12.8328 11.4337 12.8559 11.6683 12.8109 11.8946C12.7659 12.1209 12.6548 12.3288 12.4916 12.492C12.3285 12.6551 12.1206 12.7662 11.8943 12.8112C11.668 12.8563 11.4334 12.8332 11.2202 12.7449C11.007 12.6565 10.8248 12.507 10.6966 12.3152C10.5684 12.1233 10.5 11.8977 10.5 11.667V8.75033C10.5 8.13149 10.7458 7.53799 11.1834 7.10041C11.621 6.66282 12.2145 6.41699 12.8333 6.41699M3.5 10.5003H4.66667C4.89741 10.5003 5.12297 10.5687 5.31483 10.6969C5.50669 10.8251 5.65622 11.0073 5.74453 11.2205C5.83283 11.4337 5.85593 11.6683 5.81092 11.8946C5.7659 12.1209 5.65479 12.3288 5.49162 12.492C5.32846 12.6551 5.12058 12.7662 4.89427 12.8112C4.66796 12.8563 4.43338 12.8332 4.2202 12.7449C4.00702 12.6565 3.82481 12.507 3.69662 12.3152C3.56842 12.1233 3.5 11.8977 3.5 11.667V8.75033C3.5 8.13149 3.74583 7.53799 4.18342 7.10041C4.621 6.66282 5.21449 6.41699 5.83333 6.41699",
    stroke: "#57595E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6851_308533"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcnMenuNovel, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icn_menu_novel.33a9342b.svg";
export { ForwardRef as ReactComponent };